import type { Map as MapType } from "maplibre-gl";
import type { MapUpdater, UpdaterContext } from "./types";
import type { PrimitiveTarget } from "../types";
import type { PrimitivesManager } from "../managers/primitives/PrimitivesManager";

// 🌟 NOTE: Reworked from InterceptUpdater. The original had three topics:
//   "skopa/intercept"            -> generic update, kept below as "/primitives"
//   "skopa/intercept/accepted"   -> dropped (called manager.acceptIntercept, which no longer exists)
//   "skopa/intercept/rejected"   -> dropped (called manager.rejectIntercept, which no longer exists)
// If you still need accept/reject-style handshake behavior for specific
// primitive types, that's domain logic and belongs in a separate
// consumer-side class, not back in this generic updater.
export class PrimitivesUpdater implements MapUpdater {
  readonly name = "primitives";
  readonly topics = ["/primitives"];

  private primitivesManager: PrimitivesManager | null = null;

  constructor(private ctx: UpdaterContext) {}

  async initialise(map: MapType) {
    console.log("[PrimitivesUpdater] Initializing...");
    // Manager will be injected after initialization
  }

  // Called by MapEngine after PrimitivesManager is created
  setPrimitivesManager(manager: PrimitivesManager) {
    this.primitivesManager = manager;
    console.log("[PrimitivesUpdater] PrimitivesManager connected");
  }

  async handleMessage(topic: string, payload: any) {
    if (topic !== "/primitives" || !this.primitivesManager) return;

    // Accept a single primitive, an array, or { primitives: [...] }.
    const items: PrimitiveTarget[] = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.primitives)
        ? payload.primitives
        : [payload];

    for (const item of items) {
      if (!item?.primitive_id) continue;
      if (item.remove) {
        this.primitivesManager.removePrimitive(item.primitive_id);
      } else {
        this.primitivesManager.updatePrimitive(item);
      }
    }
  }

  destroy() {
    this.primitivesManager = null;
  }
}
